import createLucideIcon from '../createLucideIcon';

const ChevronUp = createLucideIcon('ChevronUp', [
  ['polyline', { points: '18 15 12 9 6 15', key: '1uugdp' }],
]);

export default ChevronUp;
